define.alias("shared/modifiers/tipalti-iframe-auto-height", "settings/modifiers/tipalti-iframe-auto-height");